export default "__VITE_ASSET__DcvAkNZ9__"